import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-100db32d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OTabelaAcordeaoProjetosAtivos__InformacoesPessoais" }
const _hoisted_2 = { class: "OTabelaAcordeaoProjetosAtivos__Nome" }

import { ref, computed } from "vue"
  import Column from "primevue/column"
  import { EntidadeGenerica } from "@/types/gerais"
  import DataTable, {
    DataTableFilterMeta,
    DataTableFilterMetaData,
  } from "primevue/datatable"
  import { FilterMatchMode, FilterOperator } from "primevue/api"
  import { useI18n } from "vue-i18n"

  interface Props {
    projetos: EntidadeGenerica[]
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTabelaAcordeaoProjetos',
  props: {
    projetos: null
  },
  setup(__props: any) {

const props = __props as {
    projetos: EntidadeGenerica[]
  }

  const filtros = ref<DataTableFilterMeta | undefined>({
    id: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      ] as DataTableFilterMetaData[],
    },
    nome: {
      operator: FilterOperator.AND,
      constraints: [
        { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      ] as DataTableFilterMetaData[],
    },
  })

  const { t } = useI18n()

  
  const projetosOrdenadosPorStatus = computed(() => {
    return ordenarProjetosPorStatus(props.projetos)
  })
  const ordenarProjetosPorStatus = (
    projetos: EntidadeGenerica[]
  ): EntidadeGenerica[] => {
    return projetos.sort(
      (a: EntidadeGenerica, b: EntidadeGenerica): number => -(+a.nome - +b.nome)
    )
  }

  const limitarTamanhoNome = (nome: string) => {
    return nome.length > 37 ? nome.slice(0, 37) + "..." : nome
  }

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PButton = _resolveComponent("PButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_unref(DataTable), {
    filters: filtros.value,
    "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => ((filtros).value = $event)),
    class: "OTabelaAcordeaoProjetos",
    "current-page-report-template": "mostrando {first} a {last} de {totalRecords}",
    "data-key": "id",
    "data-testid": "OTabelaAcordeaoProjetos",
    "filter-display": "menu",
    "global-filters-fields": ['nome', 'id'],
    paginator: "",
    "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
    "responsive-layout": "scroll",
    rows: 6,
    "striped-rows": "",
    value: _unref(projetosOrdenadosPorStatus)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        class: "OTabelaAcordeaoProjetos__Column",
        field: "nome",
        header: _unref(t)('nome'),
        sortable: ""
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(limitarTamanhoNome(data.nome)), 1)
          ])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_InputText, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            placeholder: _unref(t)('pesquisarPorNome'),
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_unref(Column), {
        class: "OTabelaAcordeaoProjetos__Column",
        field: "id",
        header: _unref(t)('codigo')
      }, {
        body: _withCtx(({ data }) => [
          _createTextVNode(_toDisplayString(data.id), 1)
        ]),
        filter: _withCtx(({ filterModel }) => [
          _createVNode(_component_InputText, {
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
            class: "p-column-filter",
            placeholder: _unref(t)('pesquisarPorCodigo'),
            type: "text"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_unref(Column), {
        class: "OTabelaAcordeaoProjetos__Column OTabelaAcordeaoProjetos__Actions",
        field: "acoes",
        header: "",
        style: {"text-align":"end"}
      }, {
        body: _withCtx(() => [
          _withDirectives(_createVNode(_component_PButton, {
            class: "OTabelaAcordeaoProjetos__IButton p-button-rounded",
            "data-testid": "OTabelaAcordeaoProjetos__IButton",
            icon: "pi pi-trash"
          }, null, 512), [
            [
              _directive_tooltip,
              _unref(t)('arquivar'),
              void 0,
              { top: true }
            ]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["filters", "value"]))
}
}

})